var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoogleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.375 20.0001C9.375 18.0183 9.92102 16.1618 10.8696 14.5722V7.82935H4.1268C1.45063 11.305 0 15.5408 0 20.0001C0 24.4593 1.45063 28.6951 4.1268 32.1708H10.8696V25.4279C9.92102 23.8383 9.375 21.9818 9.375 20.0001Z",
    fill: "#FBBD00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 30.6251L15.3125 35.3126L20 40.0001C24.4593 40.0001 28.6951 38.5495 32.1707 35.8733V29.1377H25.4351C23.8316 30.0897 21.9673 30.6251 20 30.6251Z",
    fill: "#0F9D58"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8698 25.428L4.12695 32.1708C4.6568 32.8589 5.23375 33.5179 5.85805 34.1423C9.63555 37.9197 14.658 40.0001 20.0002 40.0001V30.6251C16.1233 30.6251 12.7254 28.5376 10.8698 25.428Z",
    fill: "#31AA52"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M40 20.0001C40 18.7833 39.8898 17.5642 39.6725 16.3769L39.4966 15.416H20V24.791H29.4884C28.567 26.6239 27.1503 28.1193 25.435 29.1377L32.1706 35.8734C32.8587 35.3435 33.5177 34.7666 34.1421 34.1423C37.9196 30.3647 40 25.3423 40 20.0001Z",
    fill: "#3C79E6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27.513 12.487L28.3416 13.3155L34.9708 6.68648L34.1422 5.85789C30.3647 2.08039 25.3423 0 20 0L15.3125 4.6875L20 9.375C22.838 9.375 25.5062 10.4802 27.513 12.487Z",
    fill: "#CF2D48"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0002 9.375V0C14.658 0 9.63562 2.08039 5.85805 5.85781C5.23375 6.48211 4.6568 7.14109 4.12695 7.8293L10.8698 14.5721C12.7255 11.4625 16.1234 9.375 20.0002 9.375Z",
    fill: "#EB4132"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleIcon);
export default __webpack_public_path__ + "static/media/google_icon.57c159950fb27a8cbdd9c874108ff3d8.svg";
export { ForwardRef as ReactComponent };